import { IconAlignment } from '@/interfaces';
import EmailIcon from '../../public/images/icons/social-sharing/email.svg';
import FacebookIcon from '../../public/images/icons/social-sharing/facebook.svg';
import LinkedInIcon from '../../public/images/icons/social-sharing/linkedin.svg';
import { Button, ButtonIcon, ButtonsWrapper, SocialSharingWrapper, Title } from './SocialSharing.styles';

interface ISocialSharing {
  url: string;
  title?: string;
}

const SocialSharing: React.FC<ISocialSharing> = ({ url, title }) => {
  const encodedUrl = encodeURIComponent(url);
  const mailtoHref = title
    ? `mailto:?subject=${encodeURIComponent(title)}&body=${encodedUrl}`
    : `mailto:?body=${encodedUrl}`;

  return (
    <SocialSharingWrapper>
      <Title>Share this with your network</Title>
      <ButtonsWrapper>
        <Button
          icon={() => (
            <ButtonIcon>
              <LinkedInIcon />
            </ButtonIcon>
          )}
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
          alignment={IconAlignment.Left}
        >
          POST
        </Button>
        <Button
          icon={() => (
            <ButtonIcon>
              <FacebookIcon />
            </ButtonIcon>
          )}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
          alignment={IconAlignment.Left}
        >
          SHARE
        </Button>
        <Button
          icon={() => (
            <ButtonIcon>
              <EmailIcon />
            </ButtonIcon>
          )}
          href={mailtoHref}
          alignment={IconAlignment.Left}
        >
          EMAIL
        </Button>
      </ButtonsWrapper>
    </SocialSharingWrapper>
  );
};

export default SocialSharing;
